// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Dt-V","list":"styles_list__2YOYo"};